import request from '@/utils/request'

// 获取用户详情
export function getUserInfo(params) {
	return request({
		url: '/get_user_info',
		method: 'get',
		params
	})
}

// 修改密码
export function modifyPwd(data) {
	return request({
		url: '/edit_pwd',
		method: 'post',
		data
	})
}

// 获取头像列表
export function getAvatarList(params) {
	return request({
		url: '/avatar_list',
		method: 'get',
		params
	})
}

// 设置头像
export function setAvatar(data) {
	return request({
		url: '/set_avatar',
		method: 'post',
		data
	})
}

// 点击浏览源码守护者
export function getViewCamp(data) {
	return request({
		url: '/formalstudent/view_camp',
		method: 'post',
		data
	})
}

// 报名夏令营
export function applicationCamp(data) {
	return request({
		url: '/formalstudent/application_camp',
		method: 'post',
		data
	})
}
